<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <template v-if="possibleItems.list.sizes">
          <div class="row">
            <div v-if="isStoneFromExchange" class="col-12">
              <template>
                <button class="btn btn-block btn-secondary btn-remove-stone"
                        :class="{'lab-grown': currentItem.description.stones.diamondStock.stoneType === '5'}"
                        @click="changeItem(getPremiumStoneItemnumber())">
                  {{ $t('Menu.list.stones.group.diamondExchange.remove') }}
                </button>
              </template>
            </div>
            <div v-else class="col-10 text-start" style="cursor: pointer;" @click="toggleCurrentEdit('size')">
              <h5>{{ $t('Menu.list.stones.group.size.title') }}</h5>
              <p v-if="currentEdit != 'size'">
                <template v-if="possibleItems.list.numbers && possibleItems.list.numbers.length > 0">
                  <template v-for="(item, index) in possibleItems.list.numbers">
                    <span v-if="item.match" v-bind:key="'number_desc' + index">
                      {{ item.text }}
                      <template v-if="parseInt(item.text) > 0"> x </template>
                      <span v-if="parseInt(item.text) > 1">
                        {{ $n(currentItem.description.stones.groups[0].size / parseInt(item.text), "carat") }} ct.
                        =
                        {{ $n(currentItem.description.stones.groups[0].size, "carat") }} ct.
                      </span>
                      <span v-else>
                        {{ $n(currentItem.description.stones.groups[0].size, "carat") }} ct.
                      </span>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <span>
                      {{ $n(currentItem.description.stones.groups[0].size, "carat") }} ct.
                  </span>
                </template>
              </p>
            </div>
            <div v-if="!isStoneFromExchange" class="col-2 text-end">
              <img :src="appUrl+'/img/icons/edit.svg'" class="icon open" @click="toggleCurrentEdit('size')"
                   v-if="currentEdit != 'size'"/>
              <img :src="appUrl+'/img/icons/close.svg'" class="icon" @click="toggleCurrentEdit('size')" v-else/>
            </div>
            <div class="col-12" v-if="currentEdit == 'size'">
              <div class="row">
                <div class="col-6">
                  <div class="input-group">
                    <select @change="changeItem($event.target.value)" class="form-control">
                      <template v-if="possibleItems.list.numbers && possibleItems.list.numbers.length > 0">
                        <option v-for="(item, index) in possibleItems.list.numbers" v-bind:key="'number' + index"
                                :value="item.itemnumber" :selected="(item.match)">
                          {{ item.text }}
                        </option>
                      </template>
                      <template v-else>
                        <option value="" selected>1</option>
                      </template>
                    </select>
                    <div class="input-group-text">x</div>
                  </div>
                </div>
                <div class="col-6">
                  <select @change="changeItem($event.target.value)" class="form-control">
                    <option v-for="(item, index) in possibleItems.list.sizes" v-bind:key="'size' + index"
                            :value="item.itemnumber" :selected="(item.match)">
                      {{ item.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="row border-bottom" v-if="currentItem.description.stones.groups[0].setting">
          <div class="col-10 text-start">
            <h5>{{ $t('Menu.var.jewellery.setting') }}</h5>
            <span>{{ currentItem.description.stones.groups[0].setting }}</span>
          </div>
          <div v-if="currentItem.description.possibleVariations['jewellery/setting'] === true" class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon open" @click="configure('jewellery/setting')"/>
          </div>
        </div>
        <template v-if="!isStoneFromExchange && possibleItems.list.qualities">
          <div class="row border-bottom">
            <div class="col-12 text-start">
              <h5>{{ $t('Menu.list.stones.group.quality.quality') }}</h5>
              <div class="premium-selection"
                   v-if="currentItem.description.stones.groups[0].size / currentItem.description.stones.groups[0].number.replace(/\D/g, '') >= 0.3 && getPriceType !== ''">
                <h6>{{ $t('Menu.list.stones.qualitySpot.' + getPriceType + '.title') }}</h6>
                <ul v-if="getPriceType !== 'premium'">
                  <li v-if="$t('Menu.list.stones.qualitySpot.' + getPriceType + '.point1')">
                    {{ $t('Menu.list.stones.qualitySpot.' + getPriceType + '.point1') }}
                  </li>
                  <li v-if="$t('Menu.list.stones.qualitySpot.' + getPriceType + '.point2')">
                    {{ $t('Menu.list.stones.qualitySpot.' + getPriceType + '.point2') }}
                  </li>
                  <li v-if="$t('Menu.list.stones.qualitySpot.' + getPriceType + '.point3')">
                    {{ $t('Menu.list.stones.qualitySpot.' + getPriceType + '.point3') }}
                  </li>
                </ul>
              </div>

              <div class="lab-grown"
                   v-if="isDiamondExchange() && (
                            currentItem.description.stones.groups[0].stones[0].qualityId === 92 ||
                            currentItem.description.stones.groups[0].stones[0].qualityId === 93
                         )">
                <h6>{{ $t('Menu.list.stones.qualitySpot.labGrown.title') }}</h6>
                <ul>
                  <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point1')">
                    {{ $t('Menu.list.stones.qualitySpot.labGrown.point1') }}
                  </li>
                  <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point2')">
                    {{ $t('Menu.list.stones.qualitySpot.labGrown.point2') }}
                  </li>
                  <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point3')">
                    {{ $t('Menu.list.stones.qualitySpot.labGrown.point3') }}
                  </li>
                </ul>
              </div>

              <div class="row quality-line"
                   v-for="(item, index) in possibleItems.list.qualities"
                   v-bind:key="index"
                   :class="{'on': item.match}"
                   @click="changeItem(item.itemnumber)">
                <div class="col-9">
                  <template v-if="getPriceType !== '' && item.quality != 11">
                    {{ $t('Menu.list.stones.qualitySpot.qualityShort.' + item.quality + '') }} - {{ item.text }}
                  </template>
                  <template v-else>
                    {{ item.textShort }} - {{ item.text }}
                  </template>
                </div>
                <div class="col-3 text-end">
                  {{ $n(getPrice(item.price), 'currency') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row border-bottom"
               v-if="possibleItems.list.pools && Object.keys(possibleItems.list.pools).length > 1">
            <div class="col-12 text-start">
              <h5>{{ $t('Menu.list.stones.group.quality.color') }}</h5>
              <fieldset class="form-group change-pool">
                <select class="form-control"
                        @change="changeItem($event.target.value)">
                  <option v-for="(item, index) in possibleItems.list.pools" v-bind:key="index" :value="item.itemnumber"
                          :selected="item.match">
                    {{ item.text }}
                  </option>
                </select>
              </fieldset>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="row" v-if="currentItem.description.stones.groups[1]">
      <div class="col-12">
        <div class="row border-bottom">
          <div class="col-10 text-start" style="cursor: pointer;" @click="configure('stones/jewellery/model')">
            <h5>{{ $t('Set.Item.Description.stones.model') }}</h5>
            <p>
              {{ currentItem.description.stones.groups[1].setting }}
              {{ currentItem.description.stones.groups[1].quality.short }}
            </p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl+'/img/icons/edit.svg'" class="icon open" @click="configure('stones/jewellery/model')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'VariationsJewelleryNormal',
    props: [
      'possibleItems',
      'currentItem'
    ],
    data() {
      return {
        getApiHost: Config.getters.getApiHost,
        appUrl: Config.getters.getAppUrl,
        currentEdit: ''
      }
    },
    methods: {
      isDiamondExchange: function () {
        let stoneGroup = parseInt(this.$parent.$parent.$parent['getGroupForDiamondExchange']());
        return stoneGroup > -1;
      },
      getPrice: function(price) {
        price = price.toString();
        if (isNaN(price)) {
          price = price.toString().substr(0, price.length - 2).replace(',', '');
        }
        if (price.indexOf('.') > -1) {
          price = price.replace('.', '');
        }
        return price;
      },
      changeItem: function (itemnumber, alerts) {
        this.$parent.$parent.changeItem(itemnumber, alerts);
      },
      toggleCurrentEdit: function (id) {
        this.currentEdit = (this.currentEdit == id) ? '' : id;
      },
      configure: function (type) {
        Config.dispatch('setVisualMode', "show").then(() => {
          Config.dispatch('setCurrentVarType', type);
        });
      },
      getPremiumStoneItemnumber: function() {
        if (typeof this.$props.possibleItems == 'object' &&
            typeof this.$props.possibleItems.list == 'object' &&
            typeof this.$props.possibleItems.list.qualities == 'object' &&
            typeof this.$props.possibleItems.list.qualities[0] === 'object' &&
            typeof this.$props.possibleItems.list.qualities[0].itemnumber == 'object' &&
            typeof this.$props.possibleItems.list.qualities[0].itemnumber[0] == 'string'
        ) {
          if (Config.getters.isShopLoginActive &&
              this.$props.possibleItems.list.qualities[0].quality == 11 &&
              typeof this.$props.possibleItems.list.qualities[1] === 'object' &&
              typeof this.$props.possibleItems.list.qualities[1].itemnumber == 'object' &&
              typeof this.$props.possibleItems.list.qualities[1].itemnumber[0] == 'string'
          ) {
            return this.$props.possibleItems.list.qualities[1].itemnumber[0];
          }
          return this.$props.possibleItems.list.qualities[0].itemnumber[0];
        } else {
          return '';
        }
      }
    },
    computed: {
      getPriceType: function() {
        if (this.$props.possibleItems) {
          for (const qualityIdx in this.$props.possibleItems.list.qualities) {
            if (
                typeof this.$props.possibleItems.list.qualities[qualityIdx].priceType === "string" &&
                this.$props.possibleItems.list.qualities[qualityIdx].priceType !== ""
            ) {
              return this.$props.possibleItems.list.qualities[qualityIdx].priceType;
            }
          }
        }
        return ""
      },
      isStoneFromExchange: function() {
        return this.currentItem.description &&
               this.currentItem.description.stones.diamondStock != false &&
               this.currentItem.description.stones.diamondStock.certificate != ''
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    .border-bottom {
      padding-bottom: 1.5rem;
      margin-bottom: 1rem;

      p {
        margin: 0;
      }
    }
  }

  h5 {
    margin-bottom: 1rem !important;
  }

  .quality-line {
    line-height: 2em;
    padding: 0.5rem 0rem;
    cursor: pointer;

    div:first-child {
      padding-left: 2.25rem;
    }
  }

  .quality-line.on {
    background-color: $lightGreyBg;
    font-weight: bold;
  }

  .quality-line:hover {
    background-color: $lightGreyBg;
  }

  .btn-remove-stone {
    color: #fff;
    font-weight: bold;
    margin-bottom: 2rem;
    background-color: $gray;
    border-color: $gray;

    &.lab-grown {
      background-color: $green-lab;
      border-color: $green-lab;
    }
  }

  .premium-selection {
    margin-bottom: 1rem;

    ul {
      padding-left: 1.5rem;
    }
  }
</style>
